module.exports = __webpack_public_path__ + "img/default_status_avatar.5558db6b.svg";